/**
 * Created by rorschach on 2018/5/25.
 */
/* eslint-disable import/no-webpack-loader-syntax */

// import React from "react";
import ReactRouterUrl from "./ReactRouterUrl";
import { createLazy } from "./LazyComponent";
// import { Redirect } from "react-router-dom";
// import { FRONT_PREFIX } from "../consts/consts";
// import utils from "../utils/utils";
import PageAgreement from "bundle-loader?lazy!../pages/PageAgreement";
import PageBrand from "bundle-loader?lazy!../pages/PageBrand";
import PageZone from "bundle-loader?lazy!../pages/PageZone";
import PageBrandReport from "bundle-loader?lazy!../pages/PageBrandReport";
import PageZoneDetail from "bundle-loader?lazy!../pages/PageZoneDetail";
import PageMine from "bundle-loader?lazy!../pages/PageMine";

export const urlPageMine= new ReactRouterUrl({
  path: "/mine",
  exact: false,
  component: createLazy(PageMine)
});
export const urlPageZoneDetail= new ReactRouterUrl({
  path: "/zone/detail",
  exact: false,
  component: createLazy(PageZoneDetail)
});
export const urlPageZone = new ReactRouterUrl({
  path: "/zone",
  exact: false,
  component: createLazy(PageZone)
});


export const urlPageBrandReport = new ReactRouterUrl({
  path: "/report",
  exact: false,
  component: createLazy(PageBrandReport)
});

export const urlPageBrand = new ReactRouterUrl({
  path: "/brand",
  exact: false,
  component: createLazy(PageBrand)
});

export const urlPageAgreement = new ReactRouterUrl({
  path: "/agreement",
  exact: false,
  component: createLazy(PageAgreement)
});

export const urlPageHome = new ReactRouterUrl({
  path: "/",
  exact: false,
  component: createLazy(PageBrand)
});







// WEBPACK FOOTER //
// ./src/router/allUrls.js